import { IconButton } from '@vrplatform/components';
import { useOptionalVRPilotGuideContext } from '@vrtrust/components/vrpilot-guide/VRPilotGuideProvider';
import { useVRPilotGuideVisibility } from '@vrtrust/components/vrpilot-guide/useVRPilotGuideVisibility';

export function NavbarVRPilotGuideButton() {
  const widgetAvailable = useOptionalVRPilotGuideContext()?.widgetAvailable;
  const { hidden, toggleHidden } = useVRPilotGuideVisibility();

  if (!widgetAvailable) {
    return null;
  }

  return (
    <IconButton
      onClick={toggleHidden}
      icon={hidden ? 'EyeIcon' : 'EyeSlashIcon'}
      iconSize={18}
      color={(theme) => theme.colors.neutral[3]}
      tooltip={hidden ? 'Show VRPilot Guide' : 'Hide VRPilot Guide'}
    />
  );
}
